import {
  apiGet,
  apiPost,
  apiDelete,
} from '../../api/index';
import { urlMaterias, urlCorrelativas } from '../../api/urls';

export function fetchCorrelativasPorMateriaMalla(materiaMallaId, callback) {
  return apiGet(`${urlMaterias}/materia-malla/${materiaMallaId}/correlativas`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveCorrelativa(dto, callback) {
  return apiPost(`${urlCorrelativas}`, dto)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function deleteCorrelativa(id, callback) {
  return apiDelete(`${urlCorrelativas}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}
